export default "__VITE_ASSET__36a4ad1b__"